import { Settings, Undo2 } from 'lucide-react';
import React, { useState } from 'react';
import { useAutomationEditorContext } from '../AutomationEditorContext';
import { useEditorSyncStatus } from '../EditorSyncStatusContext';
import styles from './SettingsControls.module.css';
import { SettingsDialog } from './SettingsDialog';

export const SettingsControl: React.FC = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { editor } = useAutomationEditorContext();
  const { state, undoSettings } = editor;
  const isDirty = state.dirtySteps.settings;
  const disabled = useEditorSyncStatus();

  return (
    <>
      {isDirty && (
        <button
          type="button"
          onClick={undoSettings}
          className={styles.undoButton}
          aria-label="Undo settings changes"
          title="Undo settings changes"
          disabled={disabled}>
          <Undo2 />
        </button>
      )}
      <button
        type="button"
        onClick={() => setDialogOpen(true)}
        className={styles.settingsButton}
        disabled={disabled}
        title={disabled ? 'Not available while sync is in progress' : undefined}
        aria-label="Automation settings">
        <Settings className={styles.settingsIcon} />
      </button>
      <SettingsDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
    </>
  );
};
